<template>
  <div>
    <div class="title" @click="toggleForm">Non trovi il tuo Allestimento?</div>
    <form
      class="form-contact"
      :class="{ 'd-none': !isFormVisible }"
      action="/api/find-setup"
      method="POST"
      @submit="handleSubmit"
      ref="contactForm"
    >
      <div class="text-align-right close-form" @click="toggleForm">
        <img src="../../../images/project-img/close.svg" width="14" alt="" />
      </div>
      <div class="label">
        <label>
          Indicaci l’Allestimento della tua auto e verrai contattato dal nostro Servizio Clienti.
        </label>
        <p class="text-red" v-if="!isLogged">
          Per inviare il messaggio devi effettuare la Registrazione o il Login
        </p>
      </div>
      <template v-if="isLogged">
        <textarea
          name="contact_textarea"
          id="contact_textarea"
          rows="10"
          placeholder="Descrivi la tua auto e la relativa offerta"
          maxlength="1000"
          v-model="contactMessage"
        ></textarea>
        <div class="remaining_characters">{{ remainingCharacters }} rimanenti</div>
        <div class="text-align-right">
          <button class="button-primary mt-10" type="submit">
            <span>Invia</span>
          </button>
        </div>
      </template>
      <template v-else>
        <div class="text-align-center">
          <button class="button-primary mt-10" @click.prevent="redirectToLogin">
            <span>Login</span>
          </button>
        </div>
      </template>
    </form>
    <sw-alert
      :show="showAlert"
      :type="alertType"
      :title="alertTitle"
      :text="alertText"
      @close="resetAlert"
    />
  </div>
</template>

<script>
import SwAlert from './SwAlert.vue';
export default {
  name: 'FindEquipment',
  components: {
    SwAlert,
  },
  props: {
    loggedUser: {
      type: Object,
      required: false,
    },
    quattroruoteUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isFormVisible: false,
      contactMessage: '',
      maxCharacters: 1000,
      showAlert: false,
      alertType: 'success',
      alertTitle: '',
      alertText: '',
    };
  },
  computed: {
    isLogged() {
      return !!this.loggedUser;
    },
    remainingCharacters() {
      return this.maxCharacters - this.contactMessage.length;
    },
  },
  methods: {
    toggleForm() {
      this.isFormVisible = !this.isFormVisible;
    },
    redirectToLogin() {
      window.location.href = '/auth/domus';
    },
    async handleSubmit(event) {
      event.preventDefault();
      if (!this.contactMessage.trim()) {
        this.showAlert = true;
        this.alertType = 'error';
        this.alertTitle = 'Errore';
        this.alertText = 'Il messaggio non può essere vuoto.';
        return;
      }

      const form = this.$refs.contactForm;
      const formData = new FormData(form);

      try {
        const response = await fetch(form.action, {
          method: form.method,
          body: formData,
        });

        this.showAlert = true;

        if (response.ok) {
          this.alertType = 'success';
          this.alertTitle = 'Grazie!';
          this.alertText = 'Verrai contattato a breve dal nostro Servizio Clienti';
        } else {
          this.alertType = 'error';
          this.alertTitle = 'Errore';
          this.alertText = "Errore nell'invio del messaggio";
        }
      } catch (error) {
        this.showAlert = true;
        this.alertType = 'error';
        this.alertTitle = 'Errore';
        this.alertText = "Errore nell'invio del messaggio";
      }

      this.resetForm();
    },
    resetForm() {
      this.contactMessage = '';
      this.isFormVisible = false;
    },
    resetAlert() {
      this.showAlert = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/FindEquipment.vue